import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { useSortable, SortableContext } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import './Canvas.css';

const SortableColumn = ({ field, onClick, onRemove, selectedField }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: field.id });
console.log(`SortableColumn `)
console.log(field)
console.log(selectedField)
  let style = {
    transform: CSS.Transform.toString(transform),
    transition,
    border: (selectedField?.id ?? -1) === (field?.id ?? -2) ? '2px solid red': '0px',
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      style={style}
      className="canvas-col"
      data-colspan={field.colSpan || 1}
      onClick={(e) => {
        e.stopPropagation();
        onClick(field.id);
      }}
    >
      <div className="canvas-col-header">
        <button className="drag-handle" {...listeners}>::</button>
        <button
          className="settings-button"
          onClick={(e) => {
            e.stopPropagation();
            onClick(field.id);
          }}
        >⚙</button>
        <button
          className="remove-button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(field.id);
          }}
        >✖</button>
      </div>
      {field.type === 'header' ? (
        <h3 className="field-label">{field.label}</h3>
      ) : field.type === 'group' ? (
        <div className="field-label field-group-title">{field.label}</div>
      ) : (
        <>
          <div className="field-label">
            {field.label}
            {field.required && <span className="required-asterisk"> *</span>}
          </div>
          <div className="field-meta">Type: {field.type}</div>
        </>
      )}
    </div>
  );
};

const CanvasRow = ({ row, onSelectField, onRemoveField, selectedField }) => {
  const { setNodeRef } = useDroppable({ id: row.id });
  return (
    <div className="canvas-row" ref={setNodeRef} data-cols={row.columns.length}>
      <SortableContext items={row.columns.map(col => col.id)}>
        {row.columns.map((field) => (
          <SortableColumn
            key={field.id}
            field={field}
            onClick={onSelectField}
            onRemove={onRemoveField}
            selectedField={selectedField}
          />
        ))}
      </SortableContext>
    </div>
  );
};

const Canvas = ({ rows = [], onSelectField, onRemoveField, selectedField }) => {
  return (
    <div className="canvas">
      {rows.map((row) => (
        <CanvasRow
          key={row.id}
          row={row}
          onSelectField={onSelectField}
          onRemoveField={onRemoveField}
          selectedField={selectedField}
        />
      ))}
    </div>
  );
};

export default Canvas;
